import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getAntePostRacesSlice = createSlice({
    name: 'AntePostRaces',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchAntePostRaces.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchAntePostRaces.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchAntePostRaces.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setAntePostRaces, setStatus } = getAntePostRacesSlice.actions;
export default getAntePostRacesSlice.reducer;

export const fetchAntePostRaces = createAsyncThunk('/AntePostRacesget/fetch', async () => {
    const res = await axios.get(`${getBaseUrl()}/GetAntePostRacesV2`);
    const AntePostRacesData = res.data;
    return AntePostRacesData.data;
})